// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KoUc","col":"styles_col__MmbHg"};